import { useState } from 'react';
import { extractYouTubeId, youTubeEmbedUrl } from '@shared/youtube.js';

/**
 * הטמעת יוטיוב בתוך הטרמינל (סעיף 10) — לעולם לא נפתח בטאב חדש כברירת מחדל.
 * טעינה עצלה: ה-iframe עצמו נטען רק בלחיצה, כדי לא לטעון סרטונים מראש (סעיף 59).
 */
export function YouTubeEmbed({ url }: { url: string }) {
  const [activated, setActivated] = useState(false);
  const videoId = extractYouTubeId(url);
  if (!videoId) return null;

  return (
    <div className="yt-embed term-panel">
      <div className="yt-embed__frame">
        {activated ? (
          <iframe
            src={youTubeEmbedUrl(videoId)}
            title="סרטון משימה"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            loading="lazy"
          />
        ) : (
          <button
            type="button"
            className="yt-embed__play"
            onClick={() => setActivated(true)}
            aria-label="הפעל סרטון"
          >
            <img
              src={`https://i.ytimg.com/vi/${videoId}/hqdefault.jpg`}
              alt=""
              loading="lazy"
              className="yt-embed__thumb"
            />
            <span className="yt-embed__play-icon" aria-hidden="true">
              <svg width="28" height="28" viewBox="0 0 24 24" fill="currentColor">
                <path d="M8 5v14l11-7z" />
              </svg>
            </span>
          </button>
        )}
      </div>
    </div>
  );
}
